import React, { useState } from "react";
// eslint-disable-next-line
import {
	TabContent,
	TabPane,
	Row,
	Collapse,
	Card,
	CardHeader,
} from "reactstrap";
// import { arrowAltRight } from "fontawesome";
import ComputeTabItems from "./ComputeTabItems";
import StorageTabItems from "./StorageTabItems";
import NetworkTabItems from "./NetworkTabItems";
import SecurityTabItems from "./SecurityTabItems";
import DatabaseTabItems from "./DatabaseTabItems";
import CollaborationTabItems from "./CollaborationTabItems";

function ExploreProductsMobile(props) {
	// Tabs Selection
	const [activeTab, setActiveTab] = useState("1");
	const [activeTabName, setActiveTabName] = useState("Compute")
	const toggle = ({ id, name }) => {
        if (activeTab !== id) {
			setActiveTab(id)
			setActiveTabName(name)
		};
		dropdownToggle()
	};

	const [dropdownOpen, setDropdownOpen] = useState(false);
	const dropdownToggle = () => setDropdownOpen((prevState) => !prevState);

	return (
		<div>
			<Card>
				<CardHeader onClick={dropdownToggle}>
					<span className="font-weight-bold">{activeTabName}</span>
				</CardHeader>
				<Collapse isOpen={dropdownOpen}>
					<Row className="pl-3" onClick={() => toggle({id: "1", name: "Compute"})}>
						<img
							src={require("../../assets/Detasad Cloud/icon_computer.svg")}
							alt=""
						></img>
						<p className="button-text pt-3">Compute</p>
					</Row>
					<Row className="pl-3" onClick={() => toggle({id: "2", name: "Storage"})}>
						<img
							src={require("../../assets/Detasad Cloud/icon_storage_old.svg")}
							alt=""
						></img>
						<p className="button-text pt-3">Storage</p>
					</Row>
					<Row className="pl-3" onClick={() => toggle({id: "3", name: "Network"})}>
						<img
							src={require("../../assets/Detasad Cloud/icon_network.svg")}
							alt=""
						></img>
						<p className="button-text pt-3">Network</p>
					</Row>
					<Row className="pl-3" onClick={() => toggle({id: "4", name: "Database"})}>
						<img
							src={require("../../assets/Detasad Cloud/icon_detabase.svg")}
							alt=""
						></img>
						<p className="button-text pt-3">Database</p>
					</Row>
					<Row className="pl-3" onClick={() => toggle({id: "5", name: "Security"})}>
						<img
							src={require("../../assets/Detasad Cloud/icon_security_old.svg")}
							alt=""
						></img>
						<p className="button-text pt-3">Security</p>
					</Row>
					<Row className="pl-3" onClick={() => toggle({id: "6", name: "Collaboration & Communication"})}>
						<img
							src={require("../../assets/Detasad Cloud/icon_communication_old.svg")}
							alt=""
						></img>
						<p className="button-text pt-3">
							Collaboration & Communication
						</p>
					</Row>
				</Collapse>
			</Card>
			<div>
				<TabContent activeTab={activeTab}>
					<TabPane tabId="1">
						<ComputeTabItems />
					</TabPane>
					<TabPane tabId="2">
						<StorageTabItems />
					</TabPane>
					<TabPane tabId="3">
						<NetworkTabItems />
					</TabPane>
					<TabPane tabId="4">
						<DatabaseTabItems />
					</TabPane>
					<TabPane tabId="5">
						<SecurityTabItems />
					</TabPane>
					<TabPane tabId="6">
						<CollaborationTabItems />
					</TabPane>
				</TabContent>
			</div>
		</div>
	);
}

export default ExploreProductsMobile;
